import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcVolumeoffFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.158 2.707c.803-.73 2.092-.16 2.092.925v16.736c0 1.086-1.29 1.656-2.092.925l-4.476-4.078a.25.25 0 0 0-.17-.065H4a1.75 1.75 0 0 1-1.75-1.75V8.6c0-.967.784-1.75 1.75-1.75h2.513a.25.25 0 0 0 .169-.065zM21.47 8.47a.75.75 0 1 1 1.06 1.06L20.06 12l2.47 2.47a.75.75 0 1 1-1.06 1.06L19 13.06l-2.47 2.47a.75.75 0 1 1-1.06-1.06L17.94 12l-2.47-2.47a.75.75 0 1 1 1.06-1.06L19 10.94z"
  }));
}
var IcVolumeoffFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcVolumeoffFill));

export { IcVolumeoffFill as I };
